export const sectionsToManage = {
    TO_SHOW: 'addColumns',
    TO_HIDE: 'removeColumns',
}
